/**
 * Helpers de formatação numérica/data — usados em vários componentes do dashboard.
 *
 * Moeda de exibição: o trader é de UM mercado só (B3=BRL, Forex=USD). O TraderLayout
 * define a moeda uma vez (setDisplayCurrency) a partir do marketCode do getTraderMe;
 * assim os ~75 usos de formatBrl seguem a moeda certa sem mudar cada call site. O nome
 * "formatBrl" ficou por compat — hoje formata na moeda do trader logado.
 */
let displayCurrency: 'BRL' | 'USD' = 'BRL';

export function setDisplayCurrency(currency: 'BRL' | 'USD'): void {
  displayCurrency = currency;
}

function moneyLocale(): string {
  return displayCurrency === 'USD' ? 'en-US' : 'pt-BR';
}

export function formatBrl(cents: number, opts?: { signed?: boolean }): string {
  const value = cents / 100;
  const formatted = value.toLocaleString(moneyLocale(), {
    style: 'currency',
    currency: displayCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (opts?.signed && cents > 0) return `+${formatted}`;
  return formatted;
}

export function formatBrlCompact(cents: number): string {
  const value = cents / 100;
  return value.toLocaleString(moneyLocale(), {
    style: 'currency',
    currency: displayCurrency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export function formatPct(value: number, decimals = 2): string {
  return `${value.toFixed(decimals)}%`;
}

export function formatNumber(value: number, decimals = 2): string {
  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatDateBR(iso: string): string {
  const [y, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${y}`;
}

export function formatDateShort(iso: string): string {
  const [, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}`;
}
